import { suggestAddress as kitSuggestAddress, type MapySuggestItem } from '@redhand/ui';

/**
 * Klient napovedy adres Mapy.com (BLOK 5). Od kroku C2 zije samotny fetch
 * v kitu (`@redhand/ui`, `src/lib/mapy.ts`), aby ho mohl pouzit i verejny web —
 * tady zustava jen cteni klice z env web-adminu. Klic NIKDY natvrdo; bez
 * klice se napoveda ani mapa nevola.
 */

export { suggestItemDisplayLabel } from '@redhand/ui';
export type { MapySuggestItem } from '@redhand/ui';

export function mapyApiKey(): string {
  return (
    (import.meta as unknown as { env: Record<string, string | undefined> }).env['VITE_MAPY_API_KEY'] ??
    ''
  );
}

/**
 * Prazdne pole = zadny vysledek. `apiKeyOverride` je jen pro testy (Vite
 * nesynchronizuje `import.meta.env` s `vi.stubEnv` — viz mapy.spec.ts);
 * produkcni volani ho nikdy nepredava a cte klic z env.
 */
export function suggestAddress(
  query: string,
  signal: AbortSignal,
  apiKeyOverride?: string,
): Promise<readonly MapySuggestItem[]> {
  return kitSuggestAddress(query, signal, apiKeyOverride ?? mapyApiKey());
}
